const locale = {
  appTitle: "GISCON Map Sandbox DE",
  search: "Suche",
};

export default locale;
